<template>
  <div class="search-module" :class="{'back': activeIndex == 2}">
    <div class="tab-hander">
      <!--  :horizontalWidth="horizontalWidthLeft":itemSpacingArray="[0, 40, 40, 40]" -->
      <CustomNavbar
        :items="navbarListLeft"
        direction="horizontal"
        :horizontalWidth="'65%'"
        @handleItemClick="navbarClickLeft"
        :activeIndex="activeIndex"
      />
    </div>
    <!-- 内容网格 -->
    <component :is="rightcom" @changeTab="onClicktab" />
  </div>
</template>

<script>
// import { listIndustry} from "@/api/system/industry";
// import { articlerisgetList,deleteItem } from "@/api/tweetmanage.js"

export default {
  name: "LeftTweet",

  data() {
    return {
      rightcom: "TemplateNavbar",
      activeIndex: 2,
      textStyle: 0,
      navbarListLeft: [
        {
          label: "模版",
          value: "TemplateNavbar",
        },
        {
          label: "样式",
          value: "StyleNavbar",
        },
        {
          label: "AI生文",
          value: "AiNavbar",
        },
        {
          label: "我的",
          value: "MyNavbar",
        },
      ],
    };
  },
  computed: {},
  props: {
    refreshFlag: {
      type: Number,
      default: 0,
    },
    closeNum: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    refreshFlag: {
      handler(newVal) {
        if (newVal > 0) {
          this.getList();
        }
      },
      immediate: true,
    },
    closeNum: {
      handler(newVal) {
        if (newVal > 0) {
          this.tweetId = 0;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // this.getList()
  },
  methods: {
    navbarClickLeft(obj) {
      this.activeIndex = obj.index;
      this.rightcom = obj.item.value;
      this.$emit("changeTab", obj);
      console.log("打印左侧顶部导航栏", obj, this.rightcom);
    },
    async getList() {
      let id = null;
      if (this.activeCategory != "all") {
        id = this.activeCategory;
      }
      const res = await articlerisgetList({ industryId: id });
      console.log(res);
      this.contentItems = res.rows;
    },

    onClicktab(item) {
      console.log("leftTweent接收到的信息", item);
    },
  },
};
</script>

<style scoped lang="scss">
// 内容项样式
.content-item {
  margin-bottom: 10px;
  width: 49%;
  border: 1px solid #e0e0e0;
  border-radius: 7px;
  padding-bottom: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    border-color: #348cf8;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.content-item-active {
  border: 1px solid #348cf8;
}

// 图片容器
.image-container {
  position: relative;
  overflow: hidden;

  img {
    height: 165px;
    width: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }
}

// 悬浮遮罩层
.hover-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

// 操作按钮容器
.action-buttons {
  display: flex;
  // gap: 10px;
}

.tab-hander {
  display: flex;
  justify-content: space-evenly;
  font-size: 16px;

  .active-tab {
    border-bottom: 3px solid;
    border-image: linear-gradient(90deg, #348cf8 0%, #1b6ed4 100%) 1;
  }
}
.search-module.back{
  background-image: url('@/assets/AI_back.png');
  background-size: cover;
  background-size: 100% 100%;
}
.search-module {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 10px;
  background: white;
  min-height: 100vh;
}
</style>
